import React from 'react'
import { Button, Tag } from 'antd'
import { formatMoney } from './utils'

// Columns for the shipping-fees review table. `openEdit` opens the edit modal for a row.
// Flagged (AI-estimated, unverified) rows are made visually distinct with a red tag.
export const columns = openEdit => [
  {
    title: 'Origin',
    key: 'origin',
    render: (_, record) => record.origin?.country || '—'
  },
  {
    title: 'Body Type',
    key: 'bodyType',
    render: (_, record) => record.bodyType?.name || '—'
  },
  {
    title: 'Freight',
    key: 'freight',
    render: (_, record) =>
      formatMoney(record.shippingFeeAmount, record.shippingFeeCurrency)
  },
  {
    title: 'Insurance',
    key: 'insurance',
    render: (_, record) =>
      formatMoney(record.insuranceAmount, record.insuranceCurrency)
  },
  {
    title: 'Source',
    key: 'source',
    render: (_, record) =>
      record.isAiEstimated ? (
        <Tag color="gold">AI-estimated</Tag>
      ) : (
        <Tag color="green">Verified</Tag>
      )
  },
  {
    title: 'Review',
    key: 'review',
    render: (_, record) =>
      record.flaggedForReview ? (
        <Tag color="red">Needs review</Tag>
      ) : (
        <Tag color="default">OK</Tag>
      )
  },
  {
    title: 'Action',
    key: 'action',
    width: 120,
    render: (_, record) => (
      <Button size="small" onClick={() => openEdit(record)}>
        Edit
      </Button>
    )
  }
]
